import { render, staticRenderFns } from "./DialogReason.vue?vue&type=template&id=54ec667a&lang=pug"
import script from "./DialogReason.vue?vue&type=script&lang=js"
export * from "./DialogReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports